import { render, staticRenderFns } from "./ModifyCountry.vue?vue&type=template&id=5fa1b0d8&scoped=true&"
import script from "./ModifyCountry.vue?vue&type=script&lang=js&"
export * from "./ModifyCountry.vue?vue&type=script&lang=js&"
import style0 from "./ModifyCountry.vue?vue&type=style&index=0&id=5fa1b0d8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fa1b0d8",
  null
  
)

export default component.exports